<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Expand" class="d-icon d-icon--expand" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12"><path fill="currentColor" fill-rule="evenodd" d="M7.147 7.147a.5.5 0 0 1 .707 0L10 9.293V8.1a.5.5 0 1 1 1 0v2.4a.498.498 0 0 1-.144.351l-.004.005A.497.497 0 0 1 10.5 11H8.1a.5.5 0 0 1 0-1h1.193L7.147 7.854a.5.5 0 0 1 0-.707ZM4.854 4.854a.5.5 0 0 1-.707 0L2 2.707V3.9a.5.5 0 1 1-1 0V1.5a.499.499 0 0 1 .145-.351l.004-.005A.498.498 0 0 1 1.5 1h2.4a.5.5 0 1 1 0 1H2.707l2.147 2.147a.5.5 0 0 1 0 .707Zm0 2.293a.5.5 0 0 1 0 .707L2.707 10H3.9a.5.5 0 1 1 0 1H1.5a.498.498 0 0 1-.351-.144l-.004-.005a.499.499 0 0 1-.145-.35V8.1a.5.5 0 0 1 1 0v1.192l2.147-2.146a.5.5 0 0 1 .707 0ZM7.6 1.5a.5.5 0 0 1 .5-.5h2.4a.5.5 0 0 1 .352.144l.004.005A.499.499 0 0 1 11 1.5v2.4a.5.5 0 0 1-1 0V2.707L7.854 4.854a.5.5 0 1 1-.707-.707L9.293 2H8.1a.5.5 0 0 1-.5-.5Z" clip-rule="evenodd"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconExpand',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
